import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../utilis/api";
import { useSelector } from "react-redux";
import "./pages.css";

const Support = () => {
  const { user, token } = useSelector((s) => s.auth);
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!contactForm.name || !contactForm.email || !contactForm.message) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const response = await api.post("/contact", {
        userId: user._id, // replace with actual user ID if using authentication
        name: contactForm.name,
        email: contactForm.email,
        message: contactForm.message,
      });

      if (!response) {
        toast.error(response.data.message || "Failed to submit query");
        return;
      }

      toast.success(response.data.message || "Query submitted successfully!");
      setContactForm({ name: "", email: "", message: "" }); // reset form
    } catch (error) {
      console.error(error);
      toast.error("Server error. Please try again later.");
    }
  };
  const isMobile = window.innerWidth <= 768;
  const S = {
    card: {
      background: "linear-gradient(145deg, #111, #1a1a1a)",
      borderRadius: "20px",
      padding: isMobile ? "0.5rem" : "2rem",
      maxWidth: "600px",
      width: "95%",
      margin: "2rem auto",
      boxShadow: "0 8px 25px rgba(0,0,0,0.7)",
      color: "#fff",
    },
    title: {
      fontSize: "22px",
      fontWeight: 700,
      marginBottom: "1rem",
      color: "#e6be5d",
      textAlign: "center",
    },
    inputWrapper: { marginBottom: "1.5rem" },
    label: {
      display: "block",
      marginBottom: "6px",
      color: "#e6be5d",
      fontSize: "14px",
      fontWeight: 600,
    },
    input: {
      width: "100%",
      padding: "16px 14px 16px 12px",
      borderRadius: "12px",
      border: "1px solid #333",
      background: "#1a1a1a",
      color: "#fff",
      fontSize: "14px",
      outline: "none",
      transition: "all 0.3s ease",
    },
    textarea: {
      width: "100%",
      padding: "16px 14px 16px 12px",
      borderRadius: "12px",
      border: "1px solid #333",
      background: "#1a1a1a",
      color: "#fff",
      fontSize: "14px",
      outline: "none",
      minHeight: "140px",
      resize: "vertical",
      transition: "all 0.3s ease",
    },
    button: {
      width: "100%",
      padding: "14px 0",
      borderRadius: "12px",
      border: "none",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "16px",
      color: "#000",
      background: "linear-gradient(135deg, #e6be5d, #c9a23a)",
      boxShadow: "0 6px 18px rgba(230,190,93,0.7)",
      transition: "all 0.3s ease",
    },
  };

  return (
    <div className="contact-wrapper">
      <div style={S.card}>
        <h2 style={S.title}>Contact Support</h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: "1.5rem",
            color: "#aaa",
            fontSize: "13px",
          }}
        >
          Fill out the form below and we will get back to you.
        </p>

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div style={S.inputWrapper}>
            <label style={S.label}>Your Name</label>
            <input
              style={S.input}
              type="text"
              value={contactForm.name}
              onChange={(e) =>
                setContactForm({ ...contactForm, name: e.target.value })
              }
              required
            />
          </div>

          {/* Email */}
          <div style={S.inputWrapper}>
            <label style={S.label}>Your Email</label>
            <input
              style={S.input}
              type="email"
              value={contactForm.email}
              onChange={(e) =>
                setContactForm({ ...contactForm, email: e.target.value })
              }
              required
            />
          </div>

          {/* Message */}
          <div style={S.inputWrapper}>
            <label style={S.label}>Your Message</label>
            <textarea
              style={S.textarea}
              value={contactForm.message}
              onChange={(e) =>
                setContactForm({ ...contactForm, message: e.target.value })
              }
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            style={S.button}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-2px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0px)")
            }
          >
            Submit Query
          </button>
        </form>
      </div>
    </div>
  );
};

export default Support;
